import { Avatar, Grid2 as Grid, Typography, useMediaQuery } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import { CLUBS_DETAIL_API, USER_BY_IDS_API } from '../../api/endpoint';
import axios from 'axios';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import createAxiosInstance from '../../api/axiosConfig';
import { CDN_ALL_CLUBS_API } from '../../api/endpoint';
import usePagination from '@mui/material/usePagination/usePagination';
import rank from '../../assets/rank.png';
import ProfileImageBlur from '../../components/profileImageBlur';

const ClubDetail = () => {
  const location = useLocation();
  const { clubs } = location.state || {};
  const [stopExecution, setStopExecution] = useState<boolean | null>(false);
  const isFetching = useRef(false);
  const [clubsData, setClubsData] = useState<any>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [currentPage, setCurrentPage] = useState<string | null>(null);
  const isMobile = useMediaQuery('(max-width:600px)');
  const navigate = useNavigate();
  const scrollRefs = useRef<(HTMLDivElement | null)[]>([]);
  const scrollSpeed = 50;
  const [pageKey, setPageKey] = useState('');
  const clubId = useParams();
  const [userDetails, setUserDetails] = useState<any>([]);

  const fetchClubs = async () => {
    if (!stopExecution) {
      if (isFetching.current) return;
      isFetching.current = true;

      try {
        const axiosInstance = createAxiosInstance(false);
        const response = await axiosInstance.get(`${CLUBS_DETAIL_API}/${clubId.clubId}?page=${pageKey}&count=9`);
        if (!response?.data?.data?.length) {
          setStopExecution(true);
        } else {
          const userIds = response.data.data.map((champ: any) => champ.user_id);
          const userDetailsResponse = await axiosInstance.get(`${USER_BY_IDS_API}${userIds.join(',')}`);
          setUserDetails(userDetailsResponse.data.data);
        }
        response.data.data.length && setClubsData((prevChamps: any) => [...prevChamps, ...response.data.data]);
        setCurrentPage(response.data.page);
      } catch (error) {
        if (axios.isAxiosError(error)) {
          setError(error.message);
        } else {
          setError('An unknown error occurred');
        }
      } finally {
        setLoading(false);
        isFetching.current = false;
      }
    }
  };

  useEffect(() => {
    fetchClubs();
  }, []);

  return (
    <div>
      <div
        style={{
          margin: isMobile ? '2% 5%' : '2% 15%',
          width: isMobile ? '90%' : '70%',
          height: isMobile ? '256px' : '600px',
          boxShadow: 'inset 0 0 30px rgba(255, 255, 255, 0.5)',
          backdropFilter: 'blur(60px)',
          display: 'flex',
          borderRadius: '40px',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
          position: 'relative'
        }}>
        <img
          src={`${process.env.REACT_APP_DEFAULT_AVATAR}/APP/ClubAvatars/${clubs.avatar}`}
          style={{
            width: isMobile ? '167px' : '502px',
            height: isMobile ? '155px' : '467px',
            borderRadius: '8px',
            objectFit: 'cover'
          }}
          alt={'clubs-avatar'}
        />
        {/* Rank Image Positioned Over Avatar */}
        <img
          src={rank}
          alt="rank"
          style={{
            position: 'absolute',
            top: '28%',
            left: '50%',
            transform: 'translateX(-50%)',
            width: isMobile ? '50px' : '110px',
            height: isMobile ? '50px' : '110px',
            zIndex: 1
          }}
        />

        {/* Text Over Rank Image */}
        <span
          style={{
            position: 'absolute',
            top: isMobile ? '89px' : '34%',
            left: '50%',
            transform: 'translateX(-50%)',
            fontSize: isMobile ? '10px' : '25px',
            fontWeight: 800,
            color: '#fff',
            zIndex: 2,
            pointerEvents: 'none'
          }}>
          {clubs.condition}
        </span>
        <Typography
          style={{
            fontFamily: 'Baloo2',
            fontSize: isMobile ? '18px' : '54px',
            color: 'white',
            fontWeight: 800,
            margin: '0 2%',
            textAlign: 'center'
          }}>
          {clubs.desc}
        </Typography>
      </div>

      {userDetails.length !== 0 ? (
        <div
          style={{
            display: 'flex',
            gap: isMobile ? '21px' : '21px',
            flexWrap: 'wrap',
            margin: isMobile ? '4% 15%' : '4% 5%'
          }}>
          {userDetails.map((item: any, index: number) => (
            <div
              key={index}
              style={{
                flex: isMobile ? 'flex: 1 1 calc(100% / 3 - 18px) ' : '1 1 calc(100% / 5 - 21px)',
                maxWidth: isMobile ? 'calc(100% / 3 - 16px)' : 'calc(100% / 5 - 16px)',
                textAlign: 'center',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexDirection: 'column'
              }}>
              {/* <Avatar
                sx={{ height: isMobile ? '81px' : '197px', width: isMobile ? '81px' : '197px' }}
                alt={item?.handle}
                src={
                  item.defaultAvatar
                    ? `${process.env.REACT_APP_DEFAULT_AVATAR}/APP/UserAvatars/Avatar2.png`
                    : `${process.env.REACT_APP_DEFAULT_AVATAR}/${item.uid}/PROFILE/IMAGES/medium/${item?.avatar}`
                }></Avatar> */}
              <ProfileImageBlur
                imgHeight={isMobile ? '81px' : '197px'}
                imgWidth={isMobile ? '81px' : '197px'}
                uid={item.uid}
                avatar={item?.avatar}
                defaultAvatar={item?.defaultAvatar}
              />
              <Typography
                style={{
                  fontSize: isMobile ? '11px' : '24px',
                  fontFamily: 'Baloo2',
                  fontWeight: 700,
                  color: 'white',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  maxWidth: '100%',
                  padding: '10px 0'
                }}>
                {item.firstname}
              </Typography>
            </div>
          ))}
        </div>
      ) : (
        <Typography
          style={{
            fontFamily: 'Baloo2',
            fontSize: isMobile ? '16px' : '24px',
            textAlign: 'center',
            color: 'white',
            marginBottom: isMobile ? '20%' : '30%'
          }}>
          Champs have not joined this club yet.
        </Typography>
      )}
    </div>
  );
};
export default ClubDetail;
